<template>
  <div>
    应用方案
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>

</style>



// WEBPACK FOOTER //
// src/components/applicationPlan.vue